import Paper from '@material-ui/core/Paper';
import {
  SortingState, GroupingState, SearchState,
  IntegratedFiltering, IntegratedGrouping, IntegratedSorting
} from '@devexpress/dx-react-grid';
import {
  Grid,
  VirtualTable, TableHeaderRow, TableGroupRow,
  GroupingPanel, TableColumnReordering, Toolbar, SearchPanel,
} from '@devexpress/dx-react-grid-material-ui';
import React, { useState } from 'react';
import { connect } from 'react-redux';

const columns = [
  { title: 'Type', name: 'type'},
  { title: 'Display Name', name: 'displayName' },
  { title: 'Actions', name: 'actions' }
];

const DivisionsTable = ({  data }) => {
  const [ columnAlignment ] = useState([
    { columnName: 'actions', align: 'right'},
    { columnName: 'displayName' },
    { columnName: 'type' },
  ]);
  const [sortingStateColumnExtensions] = useState([
    { columnName: 'actions', sortingEnabled: false },
    { columnName: 'type', sortingEnabled: false },
  ]);
  const [groupingStateColumnExtensions] = useState([
    { columnName: 'actions', groupingEnabled: false }
  ]);

  return (
    <>
      <Paper>
        <Grid
          rows={data}
          columns={columns}
          getRowId={row => row.id}
        >
          <SearchState />
          <SortingState 
            defaultSorting={[
              { columnName: 'displayName', direction: 'asc' }
            ]}
            columnExtensions={sortingStateColumnExtensions}
          />
          <GroupingState
            defaultGrouping={[
              { columnName: 'type' }
            ]} 
            columnExtensions={groupingStateColumnExtensions}
          />
          <IntegratedFiltering />
          <IntegratedSorting />
          <IntegratedGrouping />
          <VirtualTable
            cellComponent={props => <VirtualTable.Cell {...props} />}
            columnExtensions={columnAlignment}
          />
          <TableHeaderRow showSortingControls />
          <TableColumnReordering defaultOrder={columns.map(column => column.name)} />
          <TableGroupRow />
          <Toolbar />
          <SearchPanel />
          <GroupingPanel showSortingControls />
        </Grid>
      </Paper>
    </>
  );
};

const mapStateToProps = state => ({
  properties: state.properties.byId,
  users: state.users.byId,
  divisions: state.divisions.byId
});

export default connect(mapStateToProps)(DivisionsTable);